import {
  CreatePrivilegeRequestPayload,
  DeletePrivilegeRequestPayload,
  GetSinglePrivilegeRequestQueryParams,
  GetSinglePrivilegeResponse,
} from '@upright/common/iam/privilege/api-types';
import { ResourcelessPermissionId } from '@upright/common/iam/privilege/permission/types';
import { fetchOrThrow, fetchOrThrowNoReturnData } from '../../common/fetchers/fetch-or-throw';
import { appendSearchParamsToUrlPath } from '@upright/common/utils/url-management';
import { PrivilegeType } from '@upright/common/iam/privilege/types';

export async function getSinglePrivilege<T extends PrivilegeType>(request: GetSinglePrivilegeRequestQueryParams<T>) {
  const url = appendSearchParamsToUrlPath('/privilege', request);
  return await fetchOrThrow<GetSinglePrivilegeResponse<T>>(url, 'GET');
}

export async function createPrivilege(payload: CreatePrivilegeRequestPayload) {
  return await fetchOrThrowNoReturnData('/privilege', 'POST', payload);
}

export async function deletePrivilege(payload: DeletePrivilegeRequestPayload) {
  return await fetchOrThrowNoReturnData('/privilege', 'DELETE', payload);
}

/**
 * Whether the current user holds the given resourceless privilege. Backed by
 * the dedicated `/me/resourceless-privilege/:permissionId` endpoint that any
 * logged-in user can call (the team-only `/privilege` admin endpoint can't
 * serve this for non-team users).
 */
export async function getMyResourcelessPrivilege(permissionId: ResourcelessPermissionId) {
  return await fetchOrThrow<{ hasPrivilege: boolean }>(
    `/me/resourceless-privilege/${encodeURIComponent(permissionId)}`,
    'GET',
  );
}
